/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "../blocks-wrapper/blocks-wrapper.component.ngfactory";
import * as i2 from "../blocks-wrapper/blocks-wrapper.component";
import * as i3 from "@angular/platform-browser";
import * as i4 from "../shared/platform/universal-platform.service";
import * as i5 from "../model/components.service";
import * as i6 from "./home.component";
import * as i7 from "../model/global.service";
import * as i8 from "../shared/platform/body.service";
import * as i9 from "../app.component";
import * as i10 from "../shared/metadata/metadata.service";
var styles_HomeComponent = [];
var RenderType_HomeComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_HomeComponent, data: {} });
export { RenderType_HomeComponent as RenderType_HomeComponent };
export function View_HomeComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "app-blocks-wrapper", [["context", "home"]], null, null, null, i1.View_BlocksWrapperComponent_0, i1.RenderType_BlocksWrapperComponent)), i0.ɵdid(1, 4440064, null, 0, i2.BlocksWrapperComponent, [i3.DomSanitizer, i4.UniversalPlatformService, i5.ComponentsService], { context: [0, "context"] }, null)], function (_ck, _v) { var currVal_0 = "home"; _ck(_v, 1, 0, currVal_0); }, null); }
export function View_HomeComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "app-home", [], null, null, null, View_HomeComponent_0, RenderType_HomeComponent)), i0.ɵdid(1, 4308992, null, 0, i6.HomeComponent, [i7.GlobalService, i8.BodyService, i9.AppComponent, i10.MetaData], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var HomeComponentNgFactory = i0.ɵccf("app-home", i6.HomeComponent, View_HomeComponent_Host_0, {}, {}, []);
export { HomeComponentNgFactory as HomeComponentNgFactory };
